(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 70151:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyArray = __webpack_require__(278),
    shuffleSelf = __webpack_require__(73480);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),

/***/ 25127:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var shuffleSelf = __webpack_require__(73480),
    values = __webpack_require__(52628);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

module.exports = baseShuffle;


/***/ }),

/***/ 47415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 73480:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseRandom = __webpack_require__(69877);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),

/***/ 69983:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayShuffle = __webpack_require__(70151),
    baseShuffle = __webpack_require__(25127),
    isArray = __webpack_require__(1469);

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

module.exports = shuffle;


/***/ }),

/***/ 52628:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseValues = __webpack_require__(47415),
    keys = __webpack_require__(3674);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(53);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17820:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
/* provided dependency */ var process = __webpack_require__(34155);
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
/*
Based on Glamor's sheet
https://github.com/threepointone/glamor/blob/667b480d31b3721a905021b26e1290ce92ca2879/src/sheet.js
*/ function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var isProd = typeof process !== "undefined" && process.env && "production" === "production";
var isString = function isString(o) {
    return Object.prototype.toString.call(o) === "[object String]";
};
var StyleSheet = /*#__PURE__*/ function() {
    var StyleSheet = function StyleSheet(param) {
        var ref = param === void 0 ? {} : param, _name = ref.name, name = _name === void 0 ? "stylesheet" : _name, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? isProd : _optimizeForSpeed;
        invariant$1(isString(name), "`name` must be a string");
        this._name = name;
        this._deletedRulePlaceholder = "#" + name + "-deleted-rule____{}";
        invariant$1(typeof optimizeForSpeed === "boolean", "`optimizeForSpeed` must be a boolean");
        this._optimizeForSpeed = optimizeForSpeed;
        this._serverSheet = undefined;
        this._tags = [];
        this._injected = false;
        this._rulesCount = 0;
        var node =  true && document.querySelector('meta[property="csp-nonce"]');
        this._nonce = node ? node.getAttribute("content") : null;
    };
    var _proto = StyleSheet.prototype;
    _proto.setOptimizeForSpeed = function setOptimizeForSpeed(bool) {
        invariant$1(typeof bool === "boolean", "`setOptimizeForSpeed` accepts a boolean");
        invariant$1(this._rulesCount === 0, "optimizeForSpeed cannot be when rules have already been inserted");
        this.flush();
        this._optimizeForSpeed = bool;
        this.inject();
    };
    _proto.isOptimizeForSpeed = function isOptimizeForSpeed() {
        return this._optimizeForSpeed;
    };
    _proto.inject = function inject() {
        var _this = this;
        invariant$1(!this._injected, "sheet already injected");
        this._injected = true;
        if ( true && this._optimizeForSpeed) {
            this._tags[0] = this.makeStyleTag(this._name);
            this._optimizeForSpeed = "insertRule" in this.getSheet();
            if (!this._optimizeForSpeed) {
                if (!isProd) {
                    console.warn("StyleSheet: optimizeForSpeed mode not supported falling back to standard mode.");
                }
                this.flush();
                this._injected = true;
            }
            return;
        }
        this._serverSheet = {
            cssRules: [],
            insertRule: function insertRule(rule, index) {
                if (typeof index === "number") {
                    _this._serverSheet.cssRules[index] = {
                        cssText: rule
                    };
                } else {
                    _this._serverSheet.cssRules.push({
                        cssText: rule
                    });
                }
                return index;
            },
            deleteRule: function deleteRule(index) {
                _this._serverSheet.cssRules[index] = null;
            }
        };
    };
    _proto.getSheetForTag = function getSheetForTag(tag) {
        if (tag.sheet) {
            return tag.sheet;
        }
        // this weirdness brought to you by firefox
        for(var i = 0; i < document.styleSheets.length; i++){
            if (document.styleSheets[i].ownerNode === tag) {
                return document.styleSheets[i];
            }
        }
    };
    _proto.getSheet = function getSheet() {
        return this.getSheetForTag(this._tags[this._tags.length - 1]);
    };
    _proto.insertRule = function insertRule(rule, index) {
        invariant$1(isString(rule), "`insertRule` accepts only strings");
        if (false) {}
        if (this._optimizeForSpeed) {
            var sheet = this.getSheet();
            if (typeof index !== "number") {
                index = sheet.cssRules.length;
            }
            // this weirdness for perf, and chrome's weird bug
            // https://stackoverflow.com/questions/20007992/chrome-suddenly-stopped-accepting-insertrule
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                return -1;
            }
        } else {
            var insertionPoint = this._tags[index];
            this._tags.push(this.makeStyleTag(this._name, rule, insertionPoint));
        }
        return this._rulesCount++;
    };
    _proto.replaceRule = function replaceRule(index, rule) {
        if (this._optimizeForSpeed || "object" === "undefined") {
            var sheet =  true ? this.getSheet() : 0;
            if (!rule.trim()) {
                rule = this._deletedRulePlaceholder;
            }
            if (!sheet.cssRules[index]) {
                // @TBD Should we throw an error?
                return index;
            }
            sheet.deleteRule(index);
            try {
                sheet.insertRule(rule, index);
            } catch (error) {
                if (!isProd) {
                    console.warn("StyleSheet: illegal rule: \n\n" + rule + "\n\nSee https://stackoverflow.com/q/20007992 for more info");
                }
                // In order to preserve the indices we insert a deleteRulePlaceholder
                sheet.insertRule(this._deletedRulePlaceholder, index);
            }
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "old rule at index `" + index + "` not found");
            tag.textContent = rule;
        }
        return index;
    };
    _proto.deleteRule = function deleteRule(index) {
        if (false) {}
        if (this._optimizeForSpeed) {
            this.replaceRule(index, "");
        } else {
            var tag = this._tags[index];
            invariant$1(tag, "rule at index `" + index + "` not found");
            tag.parentNode.removeChild(tag);
            this._tags[index] = null;
        }
    };
    _proto.flush = function flush() {
        this._injected = false;
        this._rulesCount = 0;
        if (true) {
            this._tags.forEach(function(tag) {
                return tag && tag.parentNode.removeChild(tag);
            });
            this._tags = [];
        } else {}
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        if (false) {}
        return this._tags.reduce(function(rules, tag) {
            if (tag) {
                rules = rules.concat(Array.prototype.map.call(_this.getSheetForTag(tag).cssRules, function(rule) {
                    return rule.cssText === _this._deletedRulePlaceholder ? null : rule;
                }));
            } else {
                rules.push(null);
            }
            return rules;
        }, []);
    };
    _proto.makeStyleTag = function makeStyleTag(name, cssString, relativeToTag) {
        if (cssString) {
            invariant$1(isString(cssString), "makeStyleTag accepts only strings as second parameter");
        }
        var tag = document.createElement("style");
        if (this._nonce) tag.setAttribute("nonce", this._nonce);
        tag.type = "text/css";
        tag.setAttribute("data-" + name, "");
        if (cssString) {
            tag.appendChild(document.createTextNode(cssString));
        }
        var head = document.head || document.getElementsByTagName("head")[0];
        if (relativeToTag) {
            head.insertBefore(tag, relativeToTag);
        } else {
            head.appendChild(tag);
        }
        return tag;
    };
    _createClass(StyleSheet, [
        {
            key: "length",
            get: function get() {
                return this._rulesCount;
            }
        }
    ]);
    return StyleSheet;
}();
function invariant$1(condition, message) {
    if (!condition) {
        throw new Error("StyleSheet: " + message + ".");
    }
}
function hash(str) {
    var _$hash = 5381, i = str.length;
    while(i){
        _$hash = _$hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return _$hash >>> 0;
}
var stringHash = hash;
var sanitize = function sanitize(rule) {
    return rule.replace(/\/style/gi, "\\/style");
};
var cache = {};
/**
 * computeId
 *
 * Compute and memoize a jsx id from a basedId and optionally props.
 */ function computeId(baseId, props) {
    if (!props) {
        return "jsx-" + baseId;
    }
    var propsToString = String(props);
    var key = baseId + propsToString;
    if (!cache[key]) {
        cache[key] = "jsx-" + stringHash(baseId + "-" + propsToString);
    }
    return cache[key];
}
/**
 * computeSelector
 *
 * Compute and memoize dynamic selectors.
 */ function computeSelector(id, css) {
    var selectoPlaceholderRegexp = /__jsx-style-dynamic-selector/g;
    // Sanitize SSR-ed CSS.
    // Client side code doesn't need to be sanitized since we use
    // document.createTextNode (dev) and the CSSOM api sheet.insertRule (prod).
    if (false) {}
    var idcss = id + css;
    if (!cache[idcss]) {
        cache[idcss] = css.replace(selectoPlaceholderRegexp, id);
    }
    return cache[idcss];
}
function mapRulesToStyle(cssRules, options) {
    if (options === void 0) options = {};
    return cssRules.map(function(args) {
        var id = args[0];
        var css = args[1];
        return /*#__PURE__*/ React__default["default"].createElement("style", {
            id: "__" + id,
            // Avoid warnings upon render with a key
            key: "__" + id,
            nonce: options.nonce ? options.nonce : undefined,
            dangerouslySetInnerHTML: {
                __html: css
            }
        });
    });
}
var StyleSheetRegistry = /*#__PURE__*/ function() {
    var StyleSheetRegistry = function StyleSheetRegistry(param) {
        var ref = param === void 0 ? {} : param, _styleSheet = ref.styleSheet, styleSheet = _styleSheet === void 0 ? null : _styleSheet, _optimizeForSpeed = ref.optimizeForSpeed, optimizeForSpeed = _optimizeForSpeed === void 0 ? false : _optimizeForSpeed;
        this._sheet = styleSheet || new StyleSheet({
            name: "styled-jsx",
            optimizeForSpeed: optimizeForSpeed
        });
        this._sheet.inject();
        if (styleSheet && typeof optimizeForSpeed === "boolean") {
            this._sheet.setOptimizeForSpeed(optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    var _proto = StyleSheetRegistry.prototype;
    _proto.add = function add(props) {
        var _this = this;
        if (undefined === this._optimizeForSpeed) {
            this._optimizeForSpeed = Array.isArray(props.children);
            this._sheet.setOptimizeForSpeed(this._optimizeForSpeed);
            this._optimizeForSpeed = this._sheet.isOptimizeForSpeed();
        }
        if ( true && !this._fromServer) {
            this._fromServer = this.selectFromServer();
            this._instancesCounts = Object.keys(this._fromServer).reduce(function(acc, tagName) {
                acc[tagName] = 0;
                return acc;
            }, {});
        }
        var ref = this.getIdAndRules(props), styleId = ref.styleId, rules = ref.rules;
        // Deduping: just increase the instances count.
        if (styleId in this._instancesCounts) {
            this._instancesCounts[styleId] += 1;
            return;
        }
        var indices = rules.map(function(rule) {
            return _this._sheet.insertRule(rule);
        }) // Filter out invalid rules
        .filter(function(index) {
            return index !== -1;
        });
        this._indices[styleId] = indices;
        this._instancesCounts[styleId] = 1;
    };
    _proto.remove = function remove(props) {
        var _this = this;
        var styleId = this.getIdAndRules(props).styleId;
        invariant(styleId in this._instancesCounts, "styleId: `" + styleId + "` not found");
        this._instancesCounts[styleId] -= 1;
        if (this._instancesCounts[styleId] < 1) {
            var tagFromServer = this._fromServer && this._fromServer[styleId];
            if (tagFromServer) {
                tagFromServer.parentNode.removeChild(tagFromServer);
                delete this._fromServer[styleId];
            } else {
                this._indices[styleId].forEach(function(index) {
                    return _this._sheet.deleteRule(index);
                });
                delete this._indices[styleId];
            }
            delete this._instancesCounts[styleId];
        }
    };
    _proto.update = function update(props, nextProps) {
        this.add(nextProps);
        this.remove(props);
    };
    _proto.flush = function flush() {
        this._sheet.flush();
        this._sheet.inject();
        this._fromServer = undefined;
        this._indices = {};
        this._instancesCounts = {};
    };
    _proto.cssRules = function cssRules() {
        var _this = this;
        var fromServer = this._fromServer ? Object.keys(this._fromServer).map(function(styleId) {
            return [
                styleId,
                _this._fromServer[styleId]
            ];
        }) : [];
        var cssRules1 = this._sheet.cssRules();
        return fromServer.concat(Object.keys(this._indices).map(function(styleId) {
            return [
                styleId,
                _this._indices[styleId].map(function(index) {
                    return cssRules1[index].cssText;
                }).join(_this._optimizeForSpeed ? "" : "\n")
            ];
        }) // filter out empty rules
        .filter(function(rule) {
            return Boolean(rule[1]);
        }));
    };
    _proto.styles = function styles(options) {
        return mapRulesToStyle(this.cssRules(), options);
    };
    _proto.getIdAndRules = function getIdAndRules(props) {
        var css = props.children, dynamic = props.dynamic, id = props.id;
        if (dynamic) {
            var styleId = computeId(id, dynamic);
            return {
                styleId: styleId,
                rules: Array.isArray(css) ? css.map(function(rule) {
                    return computeSelector(styleId, rule);
                }) : [
                    computeSelector(styleId, css)
                ]
            };
        }
        return {
            styleId: computeId(id),
            rules: Array.isArray(css) ? css : [
                css
            ]
        };
    };
    /**
   * selectFromServer
   *
   * Collects style tags from the document with id __jsx-XXX
   */ _proto.selectFromServer = function selectFromServer() {
        var elements = Array.prototype.slice.call(document.querySelectorAll('[id^="__jsx-"]'));
        return elements.reduce(function(acc, element) {
            var id = element.id.slice(2);
            acc[id] = element;
            return acc;
        }, {});
    };
    return StyleSheetRegistry;
}();
function invariant(condition, message) {
    if (!condition) {
        throw new Error("StyleSheetRegistry: " + message + ".");
    }
}
var StyleSheetContext = /*#__PURE__*/ React.createContext(null);
StyleSheetContext.displayName = "StyleSheetContext";
function createStyleRegistry() {
    return new StyleSheetRegistry();
}
function StyleRegistry(param) {
    var configuredRegistry = param.registry, children = param.children;
    var rootRegistry = React.useContext(StyleSheetContext);
    var ref = React.useState(function() {
        return rootRegistry || configuredRegistry || createStyleRegistry();
    }), registry = ref[0];
    return /*#__PURE__*/ React__default["default"].createElement(StyleSheetContext.Provider, {
        value: registry
    }, children);
}
function useStyleRegistry() {
    return React.useContext(StyleSheetContext);
}
// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = React__default["default"].useInsertionEffect || React__default["default"].useLayoutEffect;
var defaultRegistry =  true ? createStyleRegistry() : 0;
function JSXStyle(props) {
    var registry = defaultRegistry ? defaultRegistry : useStyleRegistry();
    // If `registry` does not exist, we do nothing here.
    if (!registry) {
        return null;
    }
    if (false) {}
    useInsertionEffect(function() {
        registry.add(props);
        return function() {
            registry.remove(props);
        };
    // props.children can be string[], will be striped since id is identical
    }, [
        props.id,
        String(props.dynamic)
    ]);
    return null;
}
JSXStyle.dynamic = function(info) {
    return info.map(function(tagInfo) {
        var baseId = tagInfo[0];
        var props = tagInfo[1];
        return computeId(baseId, props);
    }).join(" ");
};
__webpack_unused_export__ = StyleRegistry;
__webpack_unused_export__ = createStyleRegistry;
exports.style = JSXStyle;
__webpack_unused_export__ = useStyleRegistry;


/***/ }),

/***/ 52502:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(17820).style;


/***/ }),

/***/ 20838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "x": function() { return /* binding */ featureFarmApiAtom; },
  "y": function() { return /* binding */ useFeatureFlag; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/config/flag.ts
var FLAG_FARM = "pkg";

// EXTERNAL MODULE: ./node_modules/jotai/esm/index.mjs
var esm = __webpack_require__(13665);
// EXTERNAL MODULE: ./node_modules/jotai/esm/utils.mjs
var utils = __webpack_require__(39619);
;// CONCATENATED MODULE: ./src/hooks/useFeatureFlag.ts





var storage = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,utils/* createJSONStorage */.FL)(function() {
    return sessionStorage;
})), {
    delayInit: true
});
var featureFarmApiAtom = (0,utils/* atomWithStorage */.O4)("feature-farm-api", FLAG_FARM, // @ts-ignore
storage);
featureFarmApiAtom.onMount = function(set) {
    var params = new URL(window.location.href).searchParams;
    var flag = params.get("use");
    if (flag === "farmApi") {
        set("api");
    }
};
function useFeatureFlag(featureAtom) {
    return (0,esm/* useAtomValue */.Dv)(featureAtom);
}


/***/ }),

/***/ 33533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useSlowRefreshEffect; },
/* harmony export */   "a": function() { return /* binding */ useFastRefreshEffect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36305);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42918);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8100);
/* harmony import */ var _useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97477);





var EMPTY_ARRAY = [];
function useFastRefreshEffect(effect, deps) {
    var chainId = (0,_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().chainId;
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(chainId && [
        config_constants__WEBPACK_IMPORTED_MODULE_0__/* .FAST_INTERVAL */ .sR,
        "blockNumber",
        chainId
    ]), _data = ref.data, data = _data === void 0 ? 0 : _data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(effect.bind(null, data), [
        data
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(deps || EMPTY_ARRAY)));
}
function useSlowRefreshEffect(effect, deps) {
    var chainId = (0,_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().chainId;
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(chainId && [
        config_constants__WEBPACK_IMPORTED_MODULE_0__/* .SLOW_INTERVAL */ .KI,
        "blockNumber",
        chainId
    ]), _data = ref.data, data = _data === void 0 ? 0 : _data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(effect.bind(null, data), [
        data
    ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(deps || EMPTY_ARRAY)));
}


/***/ }),

/***/ 53:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/components/PageSection/index.tsx + 1 modules
var PageSection = __webpack_require__(74822);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 3 modules
var src = __webpack_require__(29315);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(27553);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var localization_src = __webpack_require__(68486);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(56797);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./public/images/thumb1.png
/* harmony default export */ var thumb1 = ({"src":"/_next/static/media/thumb1.1957f4e0.png","height":359,"width":570,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAIAAAD38zoCAAAAiElEQVR42gF9AIL/ACEhJB4lJwAAACc2HkFaLM/U2s/T3y4xOwAfJCdIPUBiUVmJklWYoACbqojc4OhJTFUAABIXkXJ12bC1qKeAo6MAn6192NzjP0NMAAAAAG5iacCiqFRYQhpPALq/vNvf5wcSIwAFAgApMDo6P0gGABkAAACqrbbKz9oAAAosTS27TjvqcQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/machine.png
/* harmony default export */ var machine = ({"src":"/_next/static/media/machine.51ac18ab.png","height":359,"width":570,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAlElEQVR42mMAgc8f/vPNXLZo94FLD1WaqvIkaxrqxBmAoKm5kYkBBBzsnedExCT8D44Iv+Dn4Z8TFhLVPWXKZGsGGGhtaz1ZWlL2383X/n9qjfeE/MqUhNDg8CoGGJg3b96WadOn/a/tyvu/aG/U/wnzS/57mccDFSCABBDbb70wZcbWczmHVDUYfoaGRG5mYGBgAAAKMjluy3J57gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/images/lapt.png
/* harmony default export */ var lapt = ({"src":"/_next/static/media/lapt.342d4aa5.png","height":1878,"width":1748,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAA30lEQVR42mNAB+WOk2Xyu12rU5us5jGcPnNy2qUrl2b31c/laFwYvWjx/pZv3duD/pfPd9rBsOnQivs7D2753zGjzqRtq9v/hvW2/9t32P4vmu7ZwXD15uWL9x7cflY93SWybbPz/641ab9m78r5X9kalMHw8PGDG5++fHp15tyxhvtPb/5/+/Hlr9u3bv3fsn6TPcPps6dPXb9+/dqqVWt2rl295v/69ev/X7p0+RLMgey379yuP3/69P/N69f8758w4cbFixeMGWDg/////EDsA8Q7gNiUAQjevHnDAgAG5oIsL+rKzAAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(52502);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
;// CONCATENATED MODULE: ./src/views/Home/components/Hero.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    transform: translate(0,  0px);\n  }\n  50% {\n    transform: translate(-5px, -5px);\n  }\n  to {\n    transform: translate(0, 0px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    opacity: 0.9;\n  }\n  50% {\n    opacity: 0.1;\n  }\n  to {\n    opacity: 0.9;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: -1;\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  bottom: 0px;\n  left: 0px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  width: 100%;\n  bottom: -3px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  animation: ",
        " 3.5s ease-in-out infinite;\n  will-change: transform;\n  margin-top: -300px;\n  img {\n    max-width: 100% !important;\n  }\n  > span {\n    overflow: visible !important; // make sure the next-image pre-build blur image not be cropped\n    right: -250px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n\n  & :nth-child(2) {\n    animation: ",
        " 2s ease-in-out infinite;\n    animation-delay: 1s;\n  }\n\n  & :nth-child(3) {\n    animation: ",
        " 5s ease-in-out infinite;\n    animation-delay: 0.66s;\n  }\n\n  & :nth-child(4) {\n    animation: ",
        " 2.5s ease-in-out infinite;\n    animation-delay: 0.33s;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





var flyingAnim = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
};
var fading = function() {
    return (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
};
var BgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68b68aff-0"
})(_templateObject2());
var InnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68b68aff-1"
})(_templateObject3());
var BunnyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68b68aff-2"
})(_templateObject4(), flyingAnim);
var StarsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-68b68aff-3"
})(_templateObject5(), fading, fading, fading);
var starsImage = {
    path: "/images/home/lunar-bunny/",
    attributes: [
        {
            src: "star-l",
            alt: "3D Star"
        },
        {
            src: "star-r",
            alt: "3D Star"
        },
        {
            src: "star-top-r",
            alt: "3D Star"
        }, 
    ]
};
var Hero = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (0,jsx_runtime.jsx)((style_default()), {
                id: "17b87fe7f0af5ff",
                children: '.slide-svg-dark{display:none}.slide-svg-light{display:block}[data-theme="dark"] .slide-svg-dark{display:block}[data-theme="dark"] .slide-svg-light{display:none}'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BgWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InnerWrapper, {})
            })
        ]
    });
};
/* harmony default export */ var components_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var immutable_dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./public/images/Investment.png
var Investment = __webpack_require__(96122);
;// CONCATENATED MODULE: ./public/images/icon-1.png
/* harmony default export */ var icon_1 = ({"src":"/_next/static/media/icon-1.b1508f22.png","height":44,"width":44,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABCElEQVR42mOAgP+c68v6nzT5rv3fGbzy/9rSCTcZYCDXqtYpWa9v77TIaf+nZC78OzNn8d+pEbP/V7hs2NoZutyWYU50/v82r4r/1Y6Nf/cXpf0/UJH2v8dv2d/ZyXP/r8ib/JshxbjxSi572f+K2p5/szbt/D9t8/r/vU3r/naZz/rf6L3yOEOef3vDcouw/wx7d/8q+Hjtf+rna/+Dtp/5tSW25X911MYChokzpvAVM1Q8tZ258r/crYu/hW6f/xUxecf/LpMFt1adO87GAAJyDP2WLgzdP8uMa/4X6tX9d2Lo+sjAMEmXAQRiDdpZGMBgtta0yKIzk8NLjjAwLFAEicQZT2IBAAxufGQSuNU3AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/icon-2.png
/* harmony default export */ var icon_2 = ({"src":"/_next/static/media/icon-2.05e81c20.png","height":46,"width":46,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA5ElEQVR42mMAga+zGVxOTav8/3Bd0sz/qxgU/61kkPy5StCeAQY+zmBI2N1Q8P/uwtgdf1Yy2L5d6RKxn6GImQEZ/JvJEPD/JAP3rUmJew/NbPz//wyDG1wySbe0sdelbU+Z3dQV63MjPx2oT/q/MX/CVLgCZ6bG2yvya/63+0z9X2LZ96/VZ8b/7MDdx+AKHPlbTpV4zPu/ILvj57aUgt++a/b9d/7/cB9cgT1/9UVv6dn/52X3/y8wXfQ/IHb5f9feTUfgCqy4SnfZC1f8NWKY8N5LdeL7IIa+/yEMHWsZGBgYANNmZJLk6s5oAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/icon-3.png
/* harmony default export */ var icon_3 = ({"src":"/_next/static/media/icon-3.cdcafd7c.png","height":47,"width":47,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABE0lEQVR4nAEIAff+AcOuuOACFhcWCgML+wAE/wEBAAH9/wAAEPz7/VAM++ixAUqKqfn8HRgGCPD5ABBp6AD6LAn/DAf+Af4H/l+dxVmjATiquPUADxUKEgX6/xNC3ABKdeP9wsgeBJfDDlb/sE4TAWBqk/X9IhAK9OgL/xu59AArLeT+1+8YA0NB6oROXniBAWMdgfj44/4HFyj9ADhM/gCXjCYAa2y6ADcf2rkcOMx9AUsii+78AgIRHBP1/xkA8PnW+wwCQXghBgobH7wmHfLIAVQmiB0XFvsMlcQv8deFk1jYK0HwbU1ciWLb5hSCJxvUAU4gigDa4AIAazvlAGx4jw27S8MKWfIXuh7v+CDxFwrAs2VxihbI1kUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Home/components/MetricsSection/index.tsx











var Stats = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var ref = (0,immutable_dist/* default */.Z)("tvl"), tvl = ref.data;
    var ref1 = (0,immutable_dist/* default */.Z)("totalTx30Days"), txCount = ref1.data;
    var ref2 = (0,immutable_dist/* default */.Z)("addressCount30Days"), addressCount = ref2.data;
    var trades = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(txCount);
    var users = (0,formatBalance/* formatLocalisedCompactNumber */.uI)(addressCount);
    var tvlString = tvl ? (0,formatBalance/* formatLocalisedCompactNumber */.uI)(tvl) : "-";
    var tvlText = t("And those users are now entrusting the platform with over $%tvl% in funds.", {
        tvl: tvlString
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(tvlText.split(tvlString), 2), entrusting = ref3[0], inFunds = ref3[1];
    var UsersCardData = {};
    var TradesCardData = {};
    var StakedCardData = {};
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
        className: "investBox",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                color: "var(--heading-color)",
                textAlign: "center",
                scale: "xl",
                children: t("Used by millions.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                color: "var(--heading-color)",
                textAlign: "center",
                scale: "xl",
                mb: "32px",
                children: t("Trusted with billions.")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "invest-sec",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "custom-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "custom-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: Investment/* default.src */.Z.src,
                                alt: "investment"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "custom-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inv-text",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "inv-para",
                                        children: t("CannabisSwap is the first decentralized exchange for cannabis fans. Our community aims to be one of the best decentralized exchanges for cryptocurrency.")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "inv-list",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: icon_1.src,
                                                        alt: "icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "1 ",
                                                                    t("Million")
                                                                ]
                                                            }),
                                                            " User",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("Within 30 Days")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: icon_2.src,
                                                        alt: "icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "1.2 ",
                                                                    t("Million")
                                                                ]
                                                            }),
                                                            " Trades",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("Within 30 Days")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: icon_3.src,
                                                        alt: "icon"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "€30 ",
                                                                    t("Million")
                                                                ]
                                                            }),
                                                            " Staking",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                children: t("Total Value Aimed")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var MetricsSection = (Stats);

// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
;// CONCATENATED MODULE: ./public/images/coin-in-hand.png
/* harmony default export */ var coin_in_hand = ({"src":"/_next/static/media/coin-in-hand.031e5792.png","height":821,"width":907,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAA5UlEQVR42mMwYwhjZACC/fv2d23dvO3nju077r588TJr2aqNWgwwcPbMuaDJk6b8dwyx/F/f2PR/64a1/zctmPZvzuIt+mAFs2bMKvMJ9PnfPCf1F4MCw9+5s2b937F21YNZs5cpwgyJAeL/WZUevyIigv+qqmr/z89rtwXL9M4PUM1rDthj6s3wv7mh4U93f+s/BgHV/wd2rXr85ubOaIa2KT7/a/q8/k8/afp/8+Ws/8u25PzvWqP7v3lW4P/VC5YsYEhrcjnqEmmw1yvK9EFYofrbgHThF26BytcZGMQbGBgYGACnmWk/Sp/x2QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});
// EXTERNAL MODULE: ./public/images/dollar-coin.png
var dollar_coin = __webpack_require__(67308);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./src/views/Home/components/SunburstSvg.tsx




var SunburstSvg = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1956 1956"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                filter: "url(#filter0_f)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M978 20L987.526 796.229L1078.14 25.248L1006.47 798.221L1177.18 40.9346L1025.11 802.182L1274.04 66.8879L1043.23 808.07L1367.65 102.823L1060.64 815.819L1457 148.348L1077.14 825.345L1541.1 202.962L1092.55 836.544L1619.03 266.067L1106.71 849.292L1689.93 336.973L1119.46 863.451L1753.04 414.902L1130.65 878.865L1807.65 499L1140.18 895.365L1853.18 588.346L1147.93 912.77L1889.11 681.962L1153.82 930.89L1915.07 778.821L1157.78 949.526L1930.75 877.862L1159.77 968.474L1936 978L1159.77 987.526L1930.75 1078.14L1157.78 1006.47L1915.07 1177.18L1153.82 1025.11L1889.11 1274.04L1147.93 1043.23L1853.18 1367.65L1140.18 1060.64L1807.65 1457L1130.65 1077.14L1753.04 1541.1L1119.46 1092.55L1689.93 1619.03L1106.71 1106.71L1619.03 1689.93L1092.55 1119.46L1541.1 1753.04L1077.14 1130.65L1457 1807.65L1060.64 1140.18L1367.65 1853.18L1043.23 1147.93L1274.04 1889.11L1025.11 1153.82L1177.18 1915.07L1006.47 1157.78L1078.14 1930.75L987.526 1159.77L978 1936L968.474 1159.77L877.862 1930.75L949.526 1157.78L778.821 1915.07L930.89 1153.82L681.962 1889.11L912.77 1147.93L588.346 1853.18L895.365 1140.18L499 1807.65L878.865 1130.65L414.902 1753.04L863.451 1119.46L336.973 1689.93L849.292 1106.71L266.067 1619.03L836.544 1092.55L202.962 1541.1L825.345 1077.14L148.348 1457L815.819 1060.64L102.823 1367.65L808.07 1043.23L66.8879 1274.04L802.182 1025.11L40.9346 1177.18L798.221 1006.47L25.248 1078.14L796.229 987.526L20 978L796.229 968.474L25.248 877.862L798.221 949.526L40.9346 778.821L802.182 930.89L66.8879 681.962L808.07 912.77L102.823 588.346L815.819 895.365L148.348 499L825.345 878.865L202.962 414.902L836.544 863.451L266.067 336.973L849.292 849.292L336.973 266.067L863.451 836.544L414.902 202.962L878.865 825.345L499 148.348L895.365 815.819L588.346 102.823L912.77 808.07L681.962 66.8879L930.89 802.182L778.821 40.9346L949.526 798.221L877.862 25.248L968.474 796.229L978 20Z",
                    fill: "url(#paint0_radial)",
                    fillOpacity: "0.1"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("filter", {
                        id: "filter0_f",
                        x: "0",
                        y: "0",
                        width: "1956",
                        height: "1956",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("feGaussianBlur", {
                                stdDeviation: "10",
                                result: "effect1_foregroundBlur"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint0_radial",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(978 978) rotate(90) scale(958)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.114547",
                                stopColor: "white",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.374975",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_SunburstSvg = (SunburstSvg);

;// CONCATENATED MODULE: ./src/views/Home/components/Footer.tsx

function Footer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n"
    ]);
    Footer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Footer_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 350%;\n  width: 350%;\n\n  ",
        " {\n    height: 400%;\n    width: 400%;\n  }\n"
    ]);
    Footer_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Footer_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    Footer_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Footer_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  visibility: hidden;\n\n  ",
        " {\n    visibility: visible;\n  }\n"
    ]);
    Footer_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Footer_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n"
    ]);
    Footer_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Footer_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: 0;\n"
    ]);
    Footer_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}











var Footer_BgWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-362b1136-0"
})(Footer_templateObject());
var StyledSunburst = (0,styled_components_browser_esm/* default */.ZP)(components_SunburstSvg).withConfig({
    componentId: "sc-362b1136-1"
})(Footer_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xl;
});
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-362b1136-2"
})(Footer_templateObject2());
var FloatingPancakesWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-362b1136-3"
})(Footer_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var TopLeftImgWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-362b1136-4"
})(Footer_templateObject4());
var BottomRightImgWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-362b1136-5"
})(Footer_templateObject5());
var topLeftImage = {
    path: "/images/home/flying-pancakes/",
    attributes: [
        {
            src: "1-bottom",
            alt: "Pancake flying on the bottom"
        },
        {
            src: "1-left",
            alt: "Pancake flying on the left"
        },
        {
            src: "1-top",
            alt: "Pancake flying on the top"
        }, 
    ]
};
var bottomRightImage = {
    path: "/images/home/flying-pancakes/",
    attributes: [
        {
            src: "2-bottom",
            alt: "Pancake flying on the bottom"
        },
        {
            src: "2-top",
            alt: "Pancake flying on the top"
        },
        {
            src: "2-right",
            alt: "Pancake flying on the right"
        }, 
    ]
};
var Footer = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isTablet = ref.isTablet, isDesktop = ref.isDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_BgWrapper, {
                style: {
                    display: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%"
                    }),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomRightImgWrapper, {
                        children: " "
                    })
                ]
            }),
            (isTablet || isDesktop) && false && /*#__PURE__*/ 0,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                className: "seconds-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "hand-coin",
                        src: coin_in_hand.src,
                        alt: "coin"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                mb: "24px",
                                scale: "xl",
                                color: "var(--heading-color)",
                                children: t("Start in seconds.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                textAlign: "center",
                                color: "var(--text-color)",
                                children: t("Connect your crypto wallet to start using the app in seconds.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                mb: "24px",
                                mt: "24px",
                                bold: true,
                                color: "var(--yellow-text)",
                                children: t("No registration needed.")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    !account && /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/blog",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "learnLink",
                                            style: {
                                                color: "var(--yellow-text)",
                                                fontWeight: "bold"
                                            },
                                            children: t("Learn how to start")
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        className: "machine-coin",
                        src: dollar_coin/* default.src */.Z.src,
                        alt: "coin"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./packages/uikit/src/util/animationToolkit.ts
var animationToolkit = __webpack_require__(37291);
// EXTERNAL MODULE: ./packages/uikit/src/hooks/useIsomorphicEffect.ts
var useIsomorphicEffect = __webpack_require__(87613);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(95867);
// EXTERNAL MODULE: ./node_modules/swiper/modules/effect-fade/effect-fade.min.css
var effect_fade_min = __webpack_require__(74227);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(9919);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
;// CONCATENATED MODULE: ./public/images/banner-img.png
/* harmony default export */ var banner_img = ({"src":"/_next/static/media/banner-img.6313a8b8.png","height":519,"width":488,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9ElEQVR42j2PvUrDUACFvxsxSSWgGRwEB+cOBV/AQUEn30CdNS3EoQkothFr1RDNrXVREE0LFrVOgm3RojTVR/B9epf2bOeHcziMIc47Ou7tjO0lZrbUMii/6aafCKi8Cw5bugZTRP0sYWeRoD2vOdfTlF5NVNLg4Mmi/udQGwacdteo/x4Tfi6L/bsMANTSdeI0wnnYxG2GVLp5IXsWXsOC4qONHKxy0Q/wngvsyBXVskWstOrHEjpoimwjhydc/uwSfReQqav4DeW2DUcvOl4yx9WgqJo2lJlXc1XCrxwT+A1D7MUZ/OYsZ72cerYAwP2/GAHa9U+mvwbJVAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/light-banner-img.png
/* harmony default export */ var light_banner_img = ({"src":"/_next/static/media/light-banner-img.14496ca5.png","height":519,"width":488,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA2ElEQVR42lWPz6pBURjFf9/Z7r637r0TxYiSkQyMFEOU2FKY0EkMKOVP6YgJJp5ASnkJnkEYeACP4SXsThn41Vdfq9VqLd5Iv+8EQNRwKACq1RLeCDgADAZBMpk/arUfBaIqFUEiEYdq9Yv5PM1mU2C/T7Ba5RiPwwIKn8kkzm5X53Yrcr16nE4G0IxGGno9jetGrejyeHR5PktcLoblMmZT/vGZzVJst4bzucn93uZ4bLBelzFG+wXt843nZa0paS/HYlFgOg19rsjnA4Cm0wnZ6F8ADgd5AZoVMyBkeWnAAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/images/community-cannabis.png
/* harmony default export */ var community_cannabis = ({"src":"/_next/static/media/community-cannabis.e17c7742.png","height":320,"width":320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA7UlEQVR42k3OvU4CQRSG4bkkf8o95+xFEBNtpJAEjRg1BgrFiSxrYEeQmXVlnWwwNmirVNpZWGtn4V1Q7I5Uh4SEhKf8vuYVS9pipa1xEtziq81wV6xqKHySKXFgiQ87yLUusLI0XJzVJlSkQVZ35MyIik5G+Zb03V5I3OrDtihfwiS4R85G6H7e16bfn5tT/UhFQwNXr7xnsd+Ct5Mb4DDG4u9rI//9WM8HD1ScGZ+P2t5Y1AOvfNBFPu3Bv9TotCUXGn/WjJEvIigtOuoRpucxcE0RH/d8lgmxSrEvVhnr70QJvlwPcJwMsbTc5w3nbo+dtLnyAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/lodash/shuffle.js
var shuffle = __webpack_require__(69983);
var shuffle_default = /*#__PURE__*/__webpack_require__.n(shuffle);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowForward.tsx
var ArrowForward = __webpack_require__(18029);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(12966);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/lottery.png
/* harmony default export */ var lottery = ({"src":"/_next/static/media/lottery.77a09738.png","height":456,"width":2291,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARUlEQVR42mOAgxcXOLof3jO5vXO27rWlmxtuHqgounKsxYbhztq7jCD566tvqO04dlfv4MRZzqc2rnxxZtukpafXzPMHAI1WH+57dZ/iAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/IFO.png
/* harmony default export */ var IFO = ({"src":"/_next/static/media/IFO.7b008469.png","height":422,"width":582,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAA0UlEQVR4nAHGADn/AbDX4QFOKB7/2QD9DazP+GLR5QAo0PP8CNz1/S8AJOaGAf///wGRu8H/T0U/FrHR6m8A9wIF/xUUBBTP0fwz9sv6AQAAAAEAAAAL////9C0BAQa4u4NV5hRKnAbl7HsZ27zyAeDb3WUEBQSN/wAA5tGhie0LKTT8By1EPs66yNIfb1ZuAero64gEAwN3+vv8ALOxsgDiCx4A+yUw/vfV1QIov6pUAdTHy5cCAQBo+vb197OsrAP79e0G++ve/hQaLAIeIy5fEQ1hlSTn6gcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/IFOMobile.png
/* harmony default export */ var IFOMobile = ({"src":"/_next/static/media/IFOMobile.a93e96d8.png","height":346,"width":338,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABAklEQVR42mPABqp6bwkF9bzUtOy84MGw9eBJRgePBcz//99kmnH3R23B4c9HLLZ92ciz5OtGpeVPT6HonPfuv+bS1asCTjz/1rr9/pfee1N7Ghkmt/Txb5w3z2rb6tXWaxgYNNYyMDjePLbqyq7D5+6cndyezvDs8ZPoV8+f/3/75t3/09vXvV9cXXr76PX77xdf+vh7YmLRO4aXL95kv3j28v/bF2/+b1q/7X9e4+T/2csO/k9Ye/5PUd/avwxHNm5oOLN716sr+/cfW1Bff6cpOflbb0LE/84g9/9zExP/M3QwMMgxMDDwMABBDQMD7+K5O5Vn9SzxnVE3o25OQc96AFPLh2ccO3aiAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/competition.png
/* harmony default export */ var competition = ({"src":"/_next/static/media/competition.67316e07.png","height":426,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOklEQVR42mMAgXj7BYwgWkM2RrTM+2jJ7sUHTpzf2/KgPGTiKgY0wFQcvDZ+Tsfig0eXlT/qKO+qAgBSTBTvrbglSwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/competitionMobile.png
/* harmony default export */ var competitionMobile = ({"src":"/_next/static/media/competitionMobile.48f2da21.png","height":364,"width":676,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAcUlEQVR42mOAgRdnahlh7JdXGa7ePOF+MEIyZypY4NOJmWDJ/9cmczzbPz3/4fk57w8ujLswLa/qP1jBtg2zmUD0+u0zlPctXvD/+O6z69dN2FK1c+bR/www8HtzDFjRjmD2nicnGDavnNt+KTdg2TMA6TQzLcAU8r8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/mod-tc-desktop.png
/* harmony default export */ var mod_tc_desktop = ({"src":"/_next/static/media/mod-tc-desktop.e1700017.png","height":677,"width":1290,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAgElEQVR42mNABld76/j+H9nKDuP/v/KfleHQ9lvCcQxZbEAu4+rIgMSFURGT/hsxiN05d1/z4fnXzQyLp+w1WlC4JH9Rw9olweGe81Iry64saMk9vDAvuvnfz/9yDFNWfmKdlTO7oa26tTeuJGOa67TedRXdzTEH0qwnnl2+kwcATX44UG7gXEAAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/mod-tc-mobile.png
/* harmony default export */ var mod_tc_mobile = ({"src":"/_next/static/media/mod-tc-mobile.92900d89.png","height":403,"width":412,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA6UlEQVR42mNABmfbJzBvZ2BgfLfkP+vz4+/Cn+x+IwOWKA9czrirZioTTOGJA1e73979/P/9ie/ZKCZcac42v92eHbZ10cask3tvTft/+78ASJyxzXeSGgPDf6YFETGTliQl/0/Vj3FH0Tkpdc6MqcXrp9Ta+dfOjLL935SdvOJYXfTux6U6ixg2F22WXVa2/P22efsvRpmalGXbGrwqbm/uak7w/3+wO7AabEKObvj2iriKh46l+f9bMqL+b6lI+V+elfA/f9MaY7CCDiM7+d45E9YlVBTMmpoftvxsnsmmgwFiVccYGHgAZVpmxlmVVcEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/lotteryMobile.png
/* harmony default export */ var lotteryMobile = ({"src":"/_next/static/media/lotteryMobile.7ad41ede.png","height":278,"width":376,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAA0UlEQVR4nAHGADn/AcLP/wEIAPT/EPbjIu/e8wI2VMbc/QYHFuzm2YX49ODzAc2/2QACAf8xBQUGIgfs1mX02PLSEEwOjvzrr+f5/+XVAZa8/w495529CvPkw/oJF0gDEQX+6ggUwgkAe2kOChTvAZqm2Swn3LK3DSAQGv4hHfsKB+IH1ckemC0rkxsSEyDXAbCiyib56AAgCS3uePUF+Ska4+t/0N8h4jMo73QJAPwOAcq21jnl6fDd4LSrBPkbIBUyRw/R6eclQg/z4wEmBdflwCZgu7ev0Q0AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/mod-white-logo.png
/* harmony default export */ var mod_white_logo = ({"src":"/_next/static/media/mod-white-logo.02856f5f.png","height":134,"width":489,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAQAAADPnVVmAAAALElEQVR42mP4J/NP55/6P+1/pv8M/un+E2L4F/6v7l/Gv9R/5f9K/9X88wcAT/wUeIPmTSsAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/perpetual.png
/* harmony default export */ var perpetual = ({"src":"/_next/static/media/perpetual.fd0aa080.png","height":464,"width":784,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAsElEQVR4nAGlAFr/AQDk/wDvaJ0hBu/7/wuLZeno1lChBeW0g95Pd9OlHkUAAe9MohH+//aJB8IAztKxEAgF/fCPD/LT2+EKA1ZFSGTlAfBElFAAAgX28Ae65AxJ79X7ISEA2AcdmkEWLg93EgXuAehIgwgEBR0yBdXW7PeULcL3Ed4VqAcNpXkFICc/+fh6Aes0lAABFwmqC7UGd/LxTavs48n7KxDwwU79B/+yz/OLcipOBbkGdywAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/perpetualMobile.png
/* harmony default export */ var perpetualMobile = ({"src":"/_next/static/media/perpetualMobile.79f3069c.png","height":416,"width":384,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAA80lEQVR4nAHoABf/AfQTjQHyVxADGZbVAAAAjv7slTPF/vz2fAISHL0B0IDHAiDFzjf6ChEqvnAaGzT0u4EI7+SzAPPh5AHrUponBu8JO/U12+TzPg2o6Q0XDwP88AIg9LjAAfFWnzTy4PpeCFK0OQEj/TQCCQ4A8wEMuh7htEcB/6C7BMBgyh4ve9+x+SoHLP8a/gD5BOa/If1YqAHh6OMEBdjw/BIeG1fm/OWo8ffH9vP71EY+Az9lAfHl7QQGEhL8+/f1XfXy7KLs78ngLQ7/sD34BuQB8dHMAf3s6//+BwkZAgbtS+sK9uFvDQUz/wwToJyEdJoheIt2AAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/Aptos.png
/* harmony default export */ var Aptos = ({"src":"/_next/static/media/Aptos.5b502f26.png","height":526,"width":2252,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAL0lEQVR42mNAB1OXRXMzXFvPcW9vy9RN0yJKUCR56yoZwYxwBu7T+xctr9w2dw8Ad2EOuYLgbLgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/AptosXPancakeSwap.png
/* harmony default export */ var AptosXPancakeSwap = ({"src":"/_next/static/media/AptosXPancakeSwap.e487f52c.png","height":73,"width":845,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJUlEQVR4nGM8Padmkkly88Z/f/9yMTIxMTMwMNwD4udArArE/ADUKQlFihUEdQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":1});
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/images/index.ts















;// CONCATENATED MODULE: ./src/views/Home/components/Banners/Styled.tsx

function Styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: -webkit-linear-gradient(#ffd800, #eb8c00);\n  font-size: 20px;\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  -webkit-text-stroke: 1px rgba(0, 0, 0, 0.5);\n  ",
        " {\n    font-size: 24px;\n  }\n  ",
        " {\n    -webkit-text-stroke: unset;\n  }\n  margin-bottom: 8px;\n"
    ]);
    Styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #ffffff;\n  background: -webkit-linear-gradient(#7645d9 0%, #452a7a 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-stroke: 6px transparent;\n  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  ",
        " {\n    margin-bottom: 16px;\n  }\n"
    ]);
    Styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 32px;\n  width: 100%;\n  max-height: max-content;\n  overflow: visible;\n  ",
        " {\n    overflow: visible;\n  }\n"
    ]);
    Styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 24px;\n  flex-direction: row;\n  justify-content: space-between;\n  max-height: 192px;\n"
    ]);
    Styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Styled_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  ",
        " {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n"
    ]);
    Styled_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Styled_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: -17px;\n  opacity: 0.9;\n  transform: translate(0, -50%);\n  top: 50%;\n\n  img {\n    height: 100%;\n    width: 500px;\n  }\n\n  ",
        " {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    right: 24px;\n    bottom: 0;\n    transform: unset;\n    opacity: 1;\n    top: unset;\n    height: 211px;\n  }\n"
    ]);
    Styled_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var StyledSubheading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-6100e55a-0"
})(Styled_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-6100e55a-1"
})(Styled_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Styled_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6100e55a-2"
})(Styled_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var Inner = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6100e55a-3"
})(Styled_templateObject3());
var LeftWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6100e55a-4"
})(Styled_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6100e55a-5"
})(Styled_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/CompetitionBanner.tsx

function CompetitionBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: -7px;\n  ",
        " {\n    bottom: 0px;\n  }\n  ",
        " {\n    bottom: 9px;\n  }\n  ",
        " {\n    bottom: -30px;\n  }\n"
    ]);
    CompetitionBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CompetitionBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    CompetitionBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CompetitionBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  margin: 10px 0 0 4px;\n  align-self: center;\n  ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    CompetitionBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var CompetitionBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c0c67f9f-0"
})(CompetitionBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Header = (0,styled_components_browser_esm/* default */.ZP)(StyledHeading).withConfig({
    componentId: "sc-c0c67f9f-1"
})(CompetitionBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var TradingCompetition = (0,styled_components_browser_esm/* default */.ZP)(StyledSubheading).withConfig({
    componentId: "sc-c0c67f9f-2"
})(CompetitionBanner_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var CompetitionBanner = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = ref.isDesktop, isMobile = ref.isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: mod_white_logo,
                                    alt: "ModLogo",
                                    width: isMobile ? "68px" : "112px",
                                    height: isMobile ? "18px" : "33px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradingCompetition, {
                                    children: t("Trading Competition")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                            width: [
                                "150px",
                                "150px",
                                "auto"
                            ],
                            children: t("$120,000 in Prizes!")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                            to: "/competition",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Trade Now")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompetitionBanner_RightWrapper, {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: mod_tc_desktop,
                        alt: "CompetitionBanner",
                        width: 632,
                        height: 338,
                        placeholder: "blur"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: mod_tc_mobile,
                        alt: "CompetitionBanner",
                        width: 206,
                        height: 201,
                        placeholder: "blur"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banners_CompetitionBanner = (/*#__PURE__*/(0,react.memo)(CompetitionBanner));

// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var swap_sdk_src = __webpack_require__(1505);
// EXTERNAL MODULE: ./src/hooks/useActiveIfoWithBlocks.ts
var useActiveIfoWithBlocks = __webpack_require__(73839);
// EXTERNAL MODULE: ./src/state/block/hooks.ts
var hooks = __webpack_require__(88770);
// EXTERNAL MODULE: ./src/views/Ifos/hooks/helpers.ts
var helpers = __webpack_require__(81379);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/IFOBanner.tsx

function IFOBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	0% {transform:translateX(-100%);}\n  20% {transform:translateX(100%);}\n	100% {transform:translateX(100%);}\n"
    ]);
    IFOBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IFOBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 1px;\n  bottom: 18px;\n  ",
        " {\n    bottom: -3px;\n    right: 0;\n  }\n  ",
        " {\n    bottom: 9px;\n    right: 67px;\n  }\n  ",
        " {\n    bottom: -3px;\n    right: 67px;\n  }\n  z-index: 0;\n"
    ]);
    IFOBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function IFOBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  background-image: ",
        ";\n  background-size: cover;\n  background-repeat: no-repeat;\n  width: 35px;\n  height: 35px;\n  bottom: 35px;\n  right: 95px;\n  overflow: hidden;\n  border-radius: 50%;\n  z-index: 2;\n  ",
        " {\n    width: 60px;\n    height: 60px;\n    bottom: 25px;\n    right: 196px;\n    z-index: 2;\n  }\n  &::after {\n    content: '';\n    top: 0;\n    transform: translateX(100%);\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 1;\n    animation: ",
        " 5s infinite 1s;\n    background: -webkit-linear-gradient(\n      left,\n      rgba(255, 255, 255, 0) 0%,\n      rgba(255, 255, 255, 0.8) 50%,\n      rgba(128, 186, 232, 0) 99%,\n      rgba(125, 185, 232, 0) 100%\n    );\n  }\n"
    ]);
    IFOBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}













var IFOHeaderMobileLimitHeight = 36;
var IFOHeaderMobileLimitWidth = 335;
var shineAnimation = (0,styled_components_browser_esm/* keyframes */.F4)(IFOBanner_templateObject());
var IFOBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43d38ac-0"
})(IFOBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var IFOIconImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43d38ac-1"
})(IFOBanner_templateObject2(), function(param) {
    var src = param.src;
    return 'url("'.concat(src, '")');
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, shineAnimation);
var IFOBanner = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var headingRef = (0,react.useRef)(null);
    var currentBlock = (0,hooks/* useChainCurrentBlock */.Mm)(swap_sdk_src/* ChainId.BSC */.a_.BSC);
    var activeIfoWithBlocks = (0,useActiveIfoWithBlocks/* useActiveIfoWithBlocks */.A)();
    var ref;
    var ifoName = (ref = activeIfoWithBlocks === null || activeIfoWithBlocks === void 0 ? void 0 : activeIfoWithBlocks.name) !== null && ref !== void 0 ? ref : "XXX";
    var isIfoAlive = !!(currentBlock && activeIfoWithBlocks && activeIfoWithBlocks.endBlock > currentBlock);
    var status = isIfoAlive ? (0,helpers/* getStatus */.l)(currentBlock, activeIfoWithBlocks.startBlock, activeIfoWithBlocks.endBlock) : null;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    (0,react.useEffect)(function() {
        if (!headingRef.current) return;
        if (!isMobile) headingRef.current.style.fontSize = "";
        else if (headingRef.current.offsetHeight > IFOHeaderMobileLimitHeight || headingRef.current.offsetWidth > IFOHeaderMobileLimitWidth) {
            headingRef.current.style.fontSize = "20px";
        }
    }, [
        isMobile
    ]);
    var ref1, ref2;
    return isIfoAlive && status ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                            children: status === "live" ? t("Live") : t("Soon")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeading, {
                            scale: "xl",
                            ref: headingRef,
                            children: [
                                ifoName,
                                " ",
                                t("IFO")
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                            to: "/ifo",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Go to IFO")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IFOBanner_RightWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IFOIconImage, {
                            src: "/images/tokens/".concat(activeIfoWithBlocks.token.address, ".png"),
                            onError: function(event) {
                                // @ts-ignore
                                // eslint-disable-next-line no-param-reassign
                                event.target.style.display = "none";
                            }
                        }),
                        !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: IFO,
                            alt: "IFO ".concat((ref1 = activeIfoWithBlocks === null || activeIfoWithBlocks === void 0 ? void 0 : activeIfoWithBlocks.id) !== null && ref1 !== void 0 ? ref1 : "XXX"),
                            width: 291,
                            height: 211,
                            placeholder: "blur"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: IFOMobile,
                            alt: "IFO ".concat((ref2 = activeIfoWithBlocks === null || activeIfoWithBlocks === void 0 ? void 0 : activeIfoWithBlocks.id) !== null && ref2 !== void 0 ? ref2 : "XXX"),
                            width: 150,
                            height: 150,
                            placeholder: "blur"
                        })
                    ]
                })
            ]
        })
    }) : null;
};
/* harmony default export */ var Banners_IFOBanner = (/*#__PURE__*/(0,react.memo)(IFOBanner));

// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(75759);
// EXTERNAL MODULE: ./src/state/farms/hooks.ts + 1 modules
var farms_hooks = __webpack_require__(48674);
// EXTERNAL MODULE: ./src/utils/getTimePeriods.ts
var getTimePeriods = __webpack_require__(13471);
// EXTERNAL MODULE: ./src/views/Lottery/components/Countdown/Timer.tsx
var Timer = __webpack_require__(97118);
// EXTERNAL MODULE: ./src/views/Lottery/hooks/useGetNextLotteryEvent.ts
var useGetNextLotteryEvent = __webpack_require__(31927);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useNextEventCountdown.ts

var useNextEventCountdown = function(nextEventTime) {
    var ref = (0,react.useState)(null), secondsRemaining = ref[0], setSecondsRemaining = ref[1];
    var timer = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var currentSeconds = Math.floor(Date.now() / 1000);
        var secondsRemainingCalc = Math.max(nextEventTime - currentSeconds, 0);
        setSecondsRemaining(secondsRemainingCalc);
        timer.current = setInterval(function() {
            setSecondsRemaining(function(prevSecondsRemaining) {
                return Math.max(prevSecondsRemaining - 1, 0);
            });
        }, 1000);
        return function() {
            return clearInterval(timer.current);
        };
    }, [
        nextEventTime
    ]);
    return secondsRemaining;
};
/* harmony default export */ var hooks_useNextEventCountdown = (useNextEventCountdown);

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/LotteryBanner.tsx

function LotteryBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: -8px;\n  ",
        " {\n    right: 1px;\n    bottom: 1px;\n  }\n  ",
        " {\n    right: 0px;\n    bottom: 8px;\n  }\n  ",
        " {\n    right: 0px;\n    bottom: -5px;\n  }\n"
    ]);
    LotteryBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LotteryBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-bottom: 16px;\n  }\n  margin-bottom: 8px;\n  .custom-timer {\n    background: url('/images/decorations/countdownBg.png');\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    padding: 0px 10px 7px;\n    display: inline-flex;\n    white-space: nowrap;\n    transform: scale(0.88);\n    transform-origin: top left;\n  }\n"
    ]);
    LotteryBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LotteryBanner_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  color: white;\n  ",
        " {\n    font-size: 24px;\n    &.lottery {\n      font-size: 20px;\n    }\n  }\n  ",
        " {\n    -webkit-text-stroke: unset;\n  }\n  margin-bottom: 8px;\n"
    ]);
    LotteryBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


















var LotteryBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-410a0169-0"
})(LotteryBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var TimerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-410a0169-1"
})(LotteryBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var LotteryBanner_StyledSubheading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-410a0169-2"
})(LotteryBanner_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.xs;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var isLotteryLive = function(status) {
    return status === types/* LotteryStatus.OPEN */.p3.OPEN;
};
var LotteryPrice = function() {
    var data = (0,dist/* default */.ZP)([
        "currentLottery"
    ]).data;
    var cakePriceBusd = (0,farms_hooks/* usePriceCakeBusd */.Iu)();
    var prizeInBusd = new bignumber/* default */.Z(data.amountCollectedInCake).times(cakePriceBusd);
    var prizeTotal = (0,formatBalance/* getBalanceNumber */.mW)(prizeInBusd);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    if (isLotteryLive(data.status)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: prizeInBusd.isNaN() ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                height: 20,
                width: 90,
                display: "inline-block"
            }) : t("Win $%prize% in Lottery", {
                prize: prizeTotal.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })
            })
        });
    }
    return null;
};
var LotteryCountDownTimer = function() {
    var data = (0,dist/* default */.ZP)([
        "currentLottery"
    ]).data;
    var endTimeAsInt = parseInt(data.endTime, 10);
    var nextEventTime = (0,useGetNextLotteryEvent/* default */.Z)(endTimeAsInt, data.status).nextEventTime;
    var secondsRemaining = hooks_useNextEventCountdown(nextEventTime);
    var ref = (0,getTimePeriods/* default */.Z)(secondsRemaining), days = ref.days, hours = ref.hours, minutes = ref.minutes, seconds = ref.seconds;
    if (isLotteryLive(data.status)) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Timer/* default */.Z, {
        wrapperClassName: "custom-timer",
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days
    });
    return null;
};
var LotteryBanner = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var ref = (0,dist/* default */.ZP)([
        "currentLottery"
    ]), data = ref.data, status = ref.status;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        status === types/* FetchStatus.Fetched */.iF.Fetched && isLotteryLive(data.status) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryBanner_StyledSubheading, {
                                    className: "lottery",
                                    style: {
                                        textShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryPrice, {})
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TimerWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryCountDownTimer, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                                    children: t("Lottery")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                                    scale: "xl",
                                    children: t("Preparing")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLinkFromReactRouter */.a, {
                            to: "/lottery",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: status === types/* FetchStatus.Fetched */.iF.Fetched && isLotteryLive(data.status) ? t("Play Now") : t("Check Now")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LotteryBanner_RightWrapper, {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: lottery,
                        alt: "LotteryBanner",
                        width: 1112,
                        height: 192 + 32,
                        placeholder: "blur"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mobile",
                        src: lotteryMobile,
                        alt: "LotteryBanner",
                        width: 190,
                        height: 144,
                        placeholder: "blur"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banners_LotteryBanner = (/*#__PURE__*/(0,react.memo)(LotteryBanner));

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(98768);
;// CONCATENATED MODULE: ./src/utils/getPerpetualLanguageCode.ts
var perpetualLangs = {
    en: "en",
    ko: "ko",
    ja: "ja",
    de: "de",
    fr: "fr",
    id: "id",
    tr: "tr",
    hi: "hi",
    ru: "ru",
    vi: "vi",
    pl: "pl",
    uk: "uk-UA",
    "es-ES": "es",
    "zh-cn": "zh-CN",
    "pt-br": "pt-BR"
};
var perpLangMap = function(languageCode) {
    if (!languageCode) {
        return "en";
    }
    if (perpetualLangs[languageCode]) {
        return perpetualLangs[languageCode];
    }
    return "en";
};

;// CONCATENATED MODULE: ./src/utils/getPerpetualTheme.ts
var perpTheme = function(isDark) {
    return isDark ? "dark" : "light";
};

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/PerpetualBanner.tsx

function PerpetualBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  min-height: 100%;\n  right: 0;\n  bottom: 0px;\n  ",
        " {\n    bottom: 8.2px;\n  }\n  ",
        " {\n    bottom: 9px;\n  }\n  ",
        " {\n    bottom: -2px;\n  }\n"
    ]);
    PerpetualBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PerpetualBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  min-height: 44px;\n  ",
        " {\n    font-size: 40px;\n    min-height: auto;\n  }\n"
    ]);
    PerpetualBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var PerpetualBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-a5b69f2e-0"
})(PerpetualBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var PerpetualBanner_Header = (0,styled_components_browser_esm/* default */.ZP)(StyledHeading).withConfig({
    componentId: "sc-a5b69f2e-1"
})(PerpetualBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var HEADING_ONE_LINE_HEIGHT = 27;
var PerpetualBanner = function() {
    var ref = (0,localization_src/* useTranslation */.$G)(), t = ref.t, code = ref.currentLanguage.code;
    var ref1 = (0,useMatchBreakpoints/* default */.Z)(), isDesktop = ref1.isDesktop, isMobile = ref1.isMobile;
    var isDark = (0,styled_components_browser_esm/* useTheme */.Fg)().isDark;
    var perpetualUrl = (0,react.useMemo)(function() {
        return "https://perp.pancakeswap.finance/".concat(perpLangMap(code), "/futures/BTCUSDT?theme=").concat(perpTheme(isDark));
    }, [
        code,
        isDark
    ]);
    var headerRef = (0,react.useRef)(null);
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        var target = headerRef.current;
        target.style.fontSize = "" // reset
        ;
        target.style.lineHeight = "";
        if (!target || !isMobile) return;
        if (target.offsetHeight > HEADING_ONE_LINE_HEIGHT) {
            target.style.fontSize = "18px";
            target.style.lineHeight = "".concat(HEADING_ONE_LINE_HEIGHT, "px");
        }
    }, [
        isMobile,
        code
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSubheading, {
                            ref: headerRef,
                            children: t("Perpetual Futures")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PerpetualBanner_Header, {
                            width: [
                                "160px",
                                "160px",
                                "auto"
                            ],
                            children: t("Up to 100\xd7 Leverage")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: perpetualUrl,
                            external: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "invertedContrast",
                                        bold: true,
                                        fontSize: "16px",
                                        mr: "4px",
                                        children: t("Trade Now")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {
                                        color: "invertedContrast"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PerpetualBanner_RightWrapper, {
                    children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: perpetual,
                        alt: "PerpetualBanner",
                        width: 392,
                        height: 232,
                        placeholder: "blur"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: perpetualMobile,
                        alt: "PerpetualBanner",
                        width: 208,
                        height: 208,
                        placeholder: "blur"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banners_PerpetualBanner = (/*#__PURE__*/(0,react.memo)(PerpetualBanner));

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useIsRenderIFOBanner.tsx



var useIsRenderIfoBanner = function() {
    var currentBlock = (0,hooks/* useChainCurrentBlock */.Mm)(swap_sdk_src/* ChainId.BSC */.a_.BSC);
    var activeIfoWithBlocks = (0,useActiveIfoWithBlocks/* useActiveIfoWithBlocks */.A)();
    return !!(currentBlock && activeIfoWithBlocks && activeIfoWithBlocks.endBlock > currentBlock);
};
/* harmony default export */ var useIsRenderIFOBanner = (useIsRenderIfoBanner);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/state/lottery/helpers.ts
var lottery_helpers = __webpack_require__(72551);
// EXTERNAL MODULE: ./src/hooks/useSWRContract.ts
var useSWRContract = __webpack_require__(22408);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(42918);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useIsRenderLotteryBanner.tsx







var useIsRenderLotteryBanner = function() {
    var ref = (0,dist/* default */.ZP)([
        "currentLotteryId"
    ], lottery_helpers/* fetchCurrentLotteryId */.kC, {
        refreshInterval: constants/* SLOW_INTERVAL */.KI,
        use: [
            useSWRContract/* immutableMiddleware */.NW
        ]
    }), currentLotteryId = ref.data, currentLotteryIdStatus = ref.status;
    var ref1 = (0,dist/* default */.ZP)(currentLotteryId ? [
        "currentLottery"
    ] : null, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,lottery_helpers/* fetchLottery */.JE)(currentLotteryId.toString())
            ];
        });
    }), {
        refreshInterval: constants/* FAST_INTERVAL */.sR,
        use: [
            useSWRContract/* immutableMiddleware */.NW
        ]
    }), currentLotteryStatus = ref1.status;
    return currentLotteryIdStatus === types/* FetchStatus.Fetched */.iF.Fetched && currentLotteryStatus === types/* FetchStatus.Fetched */.iF.Fetched;
};
/* harmony default export */ var hooks_useIsRenderLotteryBanner = (useIsRenderLotteryBanner);

// EXTERNAL MODULE: ./src/components/Menu/hooks/useCompetitionStatus.ts
var useCompetitionStatus = __webpack_require__(26745);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useIsRenderCompetitionBanner.tsx

var useIsRenderCompetitionBanner = function() {
    var competitionStatus = (0,useCompetitionStatus/* useCompetitionStatus */.U)();
    return competitionStatus !== null;
};
/* harmony default export */ var hooks_useIsRenderCompetitionBanner = (useIsRenderCompetitionBanner);

// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/OpenNew.tsx
var OpenNew = __webpack_require__(30793);
;// CONCATENATED MODULE: ./src/views/Home/components/Banners/AptosBanner.tsx

function AptosBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 0;\n  bottom: -10px;\n  ",
        " {\n    right: 1px;\n    bottom: -18px;\n  }\n  ",
        " {\n    right: 0px;\n    bottom: -21px;\n  }\n"
    ]);
    AptosBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AptosBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: 'Kanit';\n  font-style: normal;\n  font-weight: 600;\n  font-size: 23px;\n  line-height: 110%;\n  color: #ffffff;\n  text-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);\n  margin-bottom: 21px;\n  margin-top: 16px;\n\n  @media screen and (max-width: 375px) {\n    font-size: 21px;\n  }\n  ",
        " {\n    font-size: 35px;\n    margin-top: 10px;\n  }\n  ",
        " {\n    font-size: 40px;\n  }\n"
    ]);
    AptosBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var AptosBanner_RightWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-84b8b6c6-0"
})(AptosBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var AptosTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-84b8b6c6-1"
})(AptosBanner_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var AptosBanner = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Styled_Wrapper, {
        style: {
            background: "linear-gradient(180deg, #00BFA5 0%, #005A5A 100%)",
            overflow: isMobile ? "hidden" : "visible"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: AptosXPancakeSwap,
                                alt: "aptosXCannabisSwapImage",
                                width: 211,
                                height: 18,
                                placeholder: "blur"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AptosTitle, {
                            children: t("Hello Aptos Project Teams!")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            minHeight: "48px",
                            onClick: function() {
                                return window === null || window === void 0 ? void 0 : window.open("https://docs.pancakeswap.finance/aptos-deployment", "_blank", "noopener noreferrer");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    color: "invertedContrast",
                                    bold: true,
                                    fontSize: "16px",
                                    mr: "4px",
                                    children: [
                                        "\uD83D\uDC4B ",
                                        t("Get in Touch")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenNew/* default */.Z, {
                                    color: "invertedContrast"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AptosBanner_RightWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: Aptos,
                        alt: "aptosImage",
                        width: isMobile ? 1100 : 930,
                        height: isMobile ? 250 : 231,
                        placeholder: "blur"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Banners_AptosBanner = (AptosBanner);

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/hooks/useMultipleBannerConfig.tsx












/**
 * make your custom hook to control should render specific banner or not
 * add new campaign banner easily
 *
 * @example
 * ```ts
 *  {
 *    shouldRender: isRenderIFOBanner,
 *    banner: <IFOBanner />,
 *  },
 * ```
 */ var useMultipleBannerConfig = function() {
    var isRenderIFOBanner = useIsRenderIFOBanner();
    var isRenderLotteryBanner = hooks_useIsRenderLotteryBanner();
    var isRenderCompetitionBanner = hooks_useIsRenderCompetitionBanner();
    return (0,react.useMemo)(function() {
        var NO_SHUFFLE_BANNERS = [
            {
                shouldRender: false,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_AptosBanner, {})
            },
            {
                shouldRender: isRenderIFOBanner,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_IFOBanner, {})
            }, 
        ];
        var SHUFFLE_BANNERS = [
            {
                shouldRender: isRenderCompetitionBanner,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_CompetitionBanner, {})
            },
            {
                shouldRender: isRenderLotteryBanner,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_LotteryBanner, {})
            },
            {
                shouldRender: true,
                banner: /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_PerpetualBanner, {})
            }, 
        ];
        return (0,_to_consumable_array/* default */.Z)(NO_SHUFFLE_BANNERS).concat((0,_to_consumable_array/* default */.Z)(shuffle_default()(SHUFFLE_BANNERS))).filter(function(bannerConfig) {
            return bannerConfig.shouldRender;
        }).map(function(bannerConfig) {
            return bannerConfig.banner;
        });
    }, [
        isRenderIFOBanner,
        isRenderLotteryBanner,
        isRenderCompetitionBanner
    ]);
};

;// CONCATENATED MODULE: ./src/views/Home/components/Banners/MultipleBanner.tsx

function MultipleBanner_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    height: 221px;\n  }\n  ",
        " {\n    height: 232px;\n  }\n\n  @media (min-width: 768px) {\n    .br-block {\n      display: block;\n    }\n  }\n\n  ",
        " {\n    margin-top: ",
        ";\n    margin-bottom: 30px;\n  }\n  ",
        " {\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n  ",
        ",",
        " {\n    padding-top: 0;\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    MultipleBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MultipleBanner_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  overflow: visible;\n  opacity: 0;\n  animation: ",
        " 0.3s ease-in-out 0.7s forwards;\n  .swiper-pagination {\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    justify-content: center;\n    width: 108px;\n    bottom: 12px;\n    ",
        " {\n      bottom: 35px;\n    }\n    ",
        " {\n      bottom: 45px;\n    }\n    ",
        " {\n      bottom: 35px;\n    }\n  }\n  .swiper-pagination-bullet {\n    background-color: white;\n    flex-basis: 108px;\n    margin: 0 !important;\n    border-radius: 0px;\n    &:first-child {\n      border-radius: 4px 0px 0px 4px;\n    }\n    &:last-child {\n      border-radius: 0px 4px 4px 0px;\n    }\n  }\n"
    ]);
    MultipleBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

















// import Coin from '../../../../../public/images/coin-left.png'
var BannerPlaceHolder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8ce41cd8-0"
})(MultipleBanner_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "190px" : "-32px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "90px" : "-32px";
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "40px" : "30px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "60px" : "-32px";
}, function(param) {
    var walletConnected = param.walletConnected;
    return walletConnected ? "60px" : "30px";
});
var StyledSwiper = (0,styled_components_browser_esm/* default */.ZP)(swiper_react/* Swiper */.tq).withConfig({
    componentId: "sc-8ce41cd8-1"
})(MultipleBanner_templateObject1(), animationToolkit/* appearAnimation */.Oz, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var MultipleBanner = function() {
    var bannerList = useMultipleBannerConfig();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(null), swiperRef = ref[0], setSwiperRef = ref[1];
    (0,useIsomorphicEffect/* useIsomorphicEffect */.Y)(function() {
        if (swiperRef) {
            var ref, ref1;
            if (bannerList.length > 1 && !((ref = swiperRef.autoplay) === null || ref === void 0 ? void 0 : ref.running)) {
                var ref2;
                (ref2 = swiperRef.autoplay) === null || ref2 === void 0 ? void 0 : ref2.start();
            } else if (bannerList.length <= 1 && ((ref1 = swiperRef.autoplay) === null || ref1 === void 0 ? void 0 : ref1.running)) {
                var ref3;
                (ref3 = swiperRef.autoplay) === null || ref3 === void 0 ? void 0 : ref3.stop();
            }
        }
    }, [
        bannerList,
        swiperRef
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerPlaceHolder, {
            walletConnected: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "banner-sec",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "custom-row",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "custom-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "br-block",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "br-block",
                                        children: " "
                                    }),
                                    t("BUY CBC, BITCOIN & CRYPTO"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "br-block",
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/swap",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            type: "button",
                                            className: "btn btn-default custombtn mt-40",
                                            children: t("Buy crypto with 10 €")
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "custom-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "anim-coin",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "animCoin1",
                                        src: community_cannabis.src,
                                        alt: "anim-coin"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "animCoin2",
                                        src: community_cannabis.src,
                                        alt: "anim-coin"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "animCoin3",
                                        src: community_cannabis.src,
                                        alt: "anim-coin"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "coin-img",
                                        src: banner_img.src,
                                        alt: "banner-coin",
                                        style: {
                                            display: "var(--home-banner-dark-image)"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: "coin-img",
                                        src: light_banner_img.src,
                                        alt: "banner-coin",
                                        style: {
                                            display: "var(--home-banner-light-image)"
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Banners_MultipleBanner = (MultipleBanner);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx

function Home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 16px;\n\n  ",
        " {\n    // padding-top: 48px;\n  }\n"
    ]);
    Home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Home_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  z-index: 1;\n  position: absolute;\n  width: 100%;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0);\n  padding-left: 0px;\n  padding-right: 0px;\n\n  ",
        " {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n"
    ]);
    Home_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













// import * as styles from '../../styles/globals.csss'




var StyledHeroSection = (0,styled_components_browser_esm/* default */.ZP)(PageSection/* default */.Z).withConfig({
    componentId: "sc-64b5d1f5-0"
})(Home_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
});
var UserBannerWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-64b5d1f5-1"
})(Home_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Home = function() {
    var theme = (0,useTheme/* default */.ZP)().theme;
    var account = (0,src/* useWeb3React */.Ge)().account;
    var chainId = (0,useActiveChainId/* useActiveChainId */.g)().chainId;
    var HomeSectionContainerStyles = {
        margin: "0",
        width: "100%",
        maxWidth: "1400px"
    };
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroSection, {
                innerProps: {
                    style: {
                        margin: "0",
                        width: "100%"
                    }
                },
                containerProps: {
                    id: "home-1"
                },
                index: 2,
                hasCurvedDivider: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Banners_MultipleBanner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetricsSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                index: 2,
                hasCurvedDivider: false,
                containerProps: {
                    id: "home-9"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "custom-row cards-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "custom-col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "custom-card",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "img-box",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: thumb1.src,
                                                alt: "cart-thumb"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "card-cont",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    children: [
                                                        "Trade anything. No registration,",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "br-block",
                                                            children: " "
                                                        }),
                                                        " no hassle."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "Trade any token on BNB Smart Chain in seconds, ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "br-block",
                                                            children: " "
                                                        }),
                                                        " just by connecting your wallet."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "card-btns",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/blog",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            type: "button",
                                                            className: "custombtn",
                                                            children: "Read More"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "custom-col",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "custom-card",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "img-box",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: machine.src,
                                                alt: "cart-thumb"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "card-cont",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    children: [
                                                        "Earn passive income with ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "br-block",
                                                            children: " "
                                                        }),
                                                        " crypto."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                    children: [
                                                        "CannabisSwap makes it easy to make your crypto ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "br-block",
                                                            children: " "
                                                        }),
                                                        " work for you."
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "card-btns",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "/blog",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                            type: "button",
                                                            className: "custombtn",
                                                            children: "Read more"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "custom-row row1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "custom-col",
                                style: {
                                    width: "50%",
                                    paddingLeft: "100px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                        style: {
                                            fontSize: "40px",
                                            color: "var(--heading-color)",
                                            marginBottom: "30px",
                                            lineHeight: "60px"
                                        },
                                        children: [
                                            t("Shop on JointStore"),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "br-block",
                                                children: " "
                                            }),
                                            " ",
                                            t("with CBC")
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        style: {
                                            color: "var(--text-color)",
                                            marginBottom: "30px"
                                        },
                                        children: t("Join the store")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "card-btns",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "https://jointstore.de",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: "custombtn",
                                                    children: "Shop"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/buy-cbc",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    className: "border-btn",
                                                    style: {
                                                        marginLeft: "15px"
                                                    },
                                                    children: t("Buy CBC")
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "custom-col",
                                style: {
                                    width: "60%",
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    className: "machine-img",
                                    src: lapt.src,
                                    alt: "machine"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageSection/* default */.Z, {
                innerProps: {
                    style: HomeSectionContainerStyles
                },
                className: "seconds",
                index: 2,
                hasCurvedDivider: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {})
            })
        ]
    });
};
/* harmony default export */ var views_Home = (Home);

;// CONCATENATED MODULE: ./src/pages/index.tsx



var IndexPage = function(param) {
    var totalTx30Days = param.totalTx30Days, addressCount30Days = param.addressCount30Days, tvl = param.tvl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SWRConfig */.J$, {
        value: {
            fallback: {
                totalTx30Days: totalTx30Days,
                addressCount30Days: addressCount30Days,
                tvl: tvl
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(views_Home, {})
    });
};
IndexPage.chains = [];
var __N_SSG = true;
/* harmony default export */ var pages = (IndexPage);


/***/ }),

/***/ 48674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ useFarmFromPid; },
  "Dx": function() { return /* binding */ useFarmUser; },
  "E2": function() { return /* binding */ useFarms; },
  "w5": function() { return /* binding */ useLpTokenPrice; },
  "Cs": function() { return /* binding */ usePollFarmsWithUserData; },
  "Iu": function() { return /* binding */ usePriceCakeBusd; }
});

// UNUSED EXPORTS: useBusdPriceFromPid, useFarmFromLpSymbol, useFarmsLength, useFarmsPoolLength, usePollCoreFarmData

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/bignumber.js/bignumber.mjs
var bignumber = __webpack_require__(70794);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var hooks_useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(42918);
// EXTERNAL MODULE: ./src/hooks/useBUSDPrice.ts
var useBUSDPrice = __webpack_require__(2629);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/state/index.ts + 18 modules
var state = __webpack_require__(3760);
// EXTERNAL MODULE: ./node_modules/swr/immutable/dist/index.mjs
var dist = __webpack_require__(49770);
// EXTERNAL MODULE: ./src/utils/bigNumber.ts
var bigNumber = __webpack_require__(87318);
// EXTERNAL MODULE: ./src/views/Farms/hooks/useBCakeProxyContractAddress.ts
var useBCakeProxyContractAddress = __webpack_require__(80922);
// EXTERNAL MODULE: ./src/utils/contractHelpers.ts + 28 modules
var contractHelpers = __webpack_require__(27797);
// EXTERNAL MODULE: ./src/hooks/useRefreshEffect.ts
var useRefreshEffect = __webpack_require__(33533);
// EXTERNAL MODULE: ./src/hooks/useFeatureFlag.ts + 1 modules
var hooks_useFeatureFlag = __webpack_require__(20838);
// EXTERNAL MODULE: ./packages/farms/constants/index.ts
var farms_constants = __webpack_require__(37971);
// EXTERNAL MODULE: ./src/state/farms/index.ts + 1 modules
var farms = __webpack_require__(3540);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addSeconds/index.js
var addSeconds = __webpack_require__(61973);
// EXTERNAL MODULE: ./src/utils/formatBalance.ts
var formatBalance = __webpack_require__(59123);
// EXTERNAL MODULE: ./packages/utils/isUndefinedOrNull.ts
var isUndefinedOrNull = __webpack_require__(95923);
// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 5 modules
var src = __webpack_require__(40370);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var reselect_es = __webpack_require__(68697);
;// CONCATENATED MODULE: ./src/state/farms/selectors.ts








var deserializeFarmUserData = function(farm) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return {
        allowance: farm.userData ? new bignumber/* default */.Z(farm.userData.allowance) : bigNumber/* BIG_ZERO */.HW,
        tokenBalance: farm.userData ? new bignumber/* default */.Z(farm.userData.tokenBalance) : bigNumber/* BIG_ZERO */.HW,
        stakedBalance: farm.userData ? new bignumber/* default */.Z(farm.userData.stakedBalance) : bigNumber/* BIG_ZERO */.HW,
        earnings: farm.userData ? new bignumber/* default */.Z(farm.userData.earnings) : bigNumber/* BIG_ZERO */.HW,
        proxy: {
            allowance: (farm === null || farm === void 0 ? void 0 : (ref = farm.userData) === null || ref === void 0 ? void 0 : ref.proxy) ? new bignumber/* default */.Z(farm === null || farm === void 0 ? void 0 : (ref1 = farm.userData) === null || ref1 === void 0 ? void 0 : ref1.proxy.allowance) : bigNumber/* BIG_ZERO */.HW,
            tokenBalance: (farm === null || farm === void 0 ? void 0 : (ref2 = farm.userData) === null || ref2 === void 0 ? void 0 : ref2.proxy) ? new bignumber/* default */.Z(farm === null || farm === void 0 ? void 0 : (ref3 = farm.userData) === null || ref3 === void 0 ? void 0 : ref3.proxy.tokenBalance) : bigNumber/* BIG_ZERO */.HW,
            stakedBalance: (farm === null || farm === void 0 ? void 0 : (ref4 = farm.userData) === null || ref4 === void 0 ? void 0 : ref4.proxy) ? new bignumber/* default */.Z(farm === null || farm === void 0 ? void 0 : (ref5 = farm.userData) === null || ref5 === void 0 ? void 0 : ref5.proxy.stakedBalance) : bigNumber/* BIG_ZERO */.HW,
            earnings: (farm === null || farm === void 0 ? void 0 : (ref6 = farm.userData) === null || ref6 === void 0 ? void 0 : ref6.proxy) ? new bignumber/* default */.Z(farm === null || farm === void 0 ? void 0 : (ref7 = farm.userData) === null || ref7 === void 0 ? void 0 : ref7.proxy.earnings) : bigNumber/* BIG_ZERO */.HW
        }
    };
};
var deserializeFarm = function(farm) {
    var lpAddress = farm.lpAddress, lpSymbol = farm.lpSymbol, pid = farm.pid, vaultPid = farm.vaultPid, dual = farm.dual, multiplier = farm.multiplier, isCommunity = farm.isCommunity, auctionHostingStartSeconds = farm.auctionHostingStartSeconds, quoteTokenPriceBusd = farm.quoteTokenPriceBusd, tokenPriceBusd = farm.tokenPriceBusd, boosted = farm.boosted, infoStableSwapAddress = farm.infoStableSwapAddress;
    var auctionHostingStartDate = !(0,isUndefinedOrNull/* default */.Z)(auctionHostingStartSeconds) ? new Date(auctionHostingStartSeconds * 1000) : null;
    var auctionHostingEndDate = auctionHostingStartDate ? (0,addSeconds/* default */.Z)(auctionHostingStartDate, constants/* FARM_AUCTION_HOSTING_IN_SECONDS */.ki) : null;
    var now = Date.now();
    var isFarmCommunity = isCommunity || !!(auctionHostingStartDate && auctionHostingEndDate && auctionHostingStartDate.getTime() < now && auctionHostingEndDate.getTime() > now);
    return {
        lpAddress: lpAddress,
        lpSymbol: lpSymbol,
        pid: pid,
        vaultPid: vaultPid,
        dual: dual,
        multiplier: multiplier,
        isCommunity: isFarmCommunity,
        auctionHostingEndDate: auctionHostingEndDate === null || auctionHostingEndDate === void 0 ? void 0 : auctionHostingEndDate.toJSON(),
        quoteTokenPriceBusd: quoteTokenPriceBusd,
        tokenPriceBusd: tokenPriceBusd,
        token: (0,src/* deserializeToken */.iG)(farm.token),
        quoteToken: (0,src/* deserializeToken */.iG)(farm.quoteToken),
        userData: deserializeFarmUserData(farm),
        tokenAmountTotal: farm.tokenAmountTotal ? new bignumber/* default */.Z(farm.tokenAmountTotal) : bigNumber/* BIG_ZERO */.HW,
        quoteTokenAmountTotal: farm.quoteTokenAmountTotal ? new bignumber/* default */.Z(farm.quoteTokenAmountTotal) : bigNumber/* BIG_ZERO */.HW,
        lpTotalInQuoteToken: farm.lpTotalInQuoteToken ? new bignumber/* default */.Z(farm.lpTotalInQuoteToken) : bigNumber/* BIG_ZERO */.HW,
        lpTotalSupply: farm.lpTotalSupply ? new bignumber/* default */.Z(farm.lpTotalSupply) : bigNumber/* BIG_ZERO */.HW,
        lpTokenPrice: farm.lpTokenPrice ? new bignumber/* default */.Z(farm.lpTokenPrice) : bigNumber/* BIG_ZERO */.HW,
        tokenPriceVsQuote: farm.tokenPriceVsQuote ? new bignumber/* default */.Z(farm.tokenPriceVsQuote) : bigNumber/* BIG_ZERO */.HW,
        poolWeight: farm.poolWeight ? new bignumber/* default */.Z(farm.poolWeight) : bigNumber/* BIG_ZERO */.HW,
        boosted: boosted,
        isStable: Boolean(infoStableSwapAddress)
    };
};
var selectCakeFarm = function(state) {
    return state.farms.data.find(function(f) {
        return f.pid === 2;
    });
};
var selectFarmByKey = function(key, value) {
    return function(state) {
        return state.farms.data.find(function(f) {
            return f[key] === value;
        });
    };
};
var makeFarmFromPidSelector = function(pid) {
    return (0,reselect_es/* createSelector */.P1)([
        selectFarmByKey("pid", pid)
    ], function(farm) {
        return deserializeFarm(farm);
    });
};
var selectors_makeBusdPriceFromPidSelector = function(pid) {
    return createSelector([
        selectFarmByKey("pid", pid)
    ], function(farm) {
        return farm && new BigNumber(farm.tokenPriceBusd);
    });
};
var makeUserFarmFromPidSelector = function(pid) {
    return (0,reselect_es/* createSelector */.P1)([
        selectFarmByKey("pid", pid)
    ], function(farm) {
        var ref = deserializeFarmUserData(farm), allowance = ref.allowance, tokenBalance = ref.tokenBalance, stakedBalance = ref.stakedBalance, earnings = ref.earnings, proxy = ref.proxy;
        return {
            allowance: allowance,
            tokenBalance: tokenBalance,
            stakedBalance: stakedBalance,
            earnings: earnings,
            proxy: proxy
        };
    });
};
var priceCakeFromPidSelector = (0,reselect_es/* createSelector */.P1)([
    selectCakeFarm
], function(cakeBnbFarm) {
    var cakePriceBusdAsString = cakeBnbFarm === null || cakeBnbFarm === void 0 ? void 0 : cakeBnbFarm.tokenPriceBusd;
    return new bignumber/* default */.Z(cakePriceBusdAsString);
});
var selectors_farmFromLpSymbolSelector = function(lpSymbol) {
    return createSelector([
        selectFarmByKey("lpSymbol", lpSymbol)
    ], function(farm) {
        return deserializeFarm(farm);
    });
};
var makeLpTokenPriceFromLpSymbolSelector = function(lpSymbol) {
    return (0,reselect_es/* createSelector */.P1)([
        selectFarmByKey("lpSymbol", lpSymbol)
    ], function(farm) {
        var lpTokenPrice = bigNumber/* BIG_ZERO */.HW;
        if (farm) {
            var lpTotalInQuoteToken = farm.lpTotalInQuoteToken ? new bignumber/* default */.Z(farm.lpTotalInQuoteToken) : bigNumber/* BIG_ZERO */.HW;
            var lpTotalSupply = farm.lpTotalSupply ? new bignumber/* default */.Z(farm.lpTotalSupply) : bigNumber/* BIG_ZERO */.HW;
            if (lpTotalSupply.gt(0) && lpTotalInQuoteToken.gt(0)) {
                var farmTokenPriceInUsd = new bignumber/* default */.Z(farm.tokenPriceBusd);
                var tokenAmountTotal = farm.tokenAmountTotal ? new bignumber/* default */.Z(farm.tokenAmountTotal) : bigNumber/* BIG_ZERO */.HW;
                // Total value of base token in LP
                var valueOfBaseTokenInFarm = farmTokenPriceInUsd.times(tokenAmountTotal);
                // Double it to get overall value in LP
                var overallValueOfAllTokensInFarm = valueOfBaseTokenInFarm.times(2);
                // Divide total value of all tokens, by the number of LP tokens
                var totalLpTokens = (0,formatBalance/* getBalanceAmount */.U4)(lpTotalSupply);
                lpTokenPrice = overallValueOfAllTokensInFarm.div(totalLpTokens);
            }
        }
        return lpTokenPrice;
    });
};
var farmSelector = function(chainId) {
    return (0,reselect_es/* createSelector */.P1)(function(state) {
        return state.farms;
    }, function(farms) {
        var deserializedFarmsData = farms.data.map(deserializeFarm).filter(function(farm) {
            return farm.token.chainId === chainId;
        });
        var loadArchivedFarmsData = farms.loadArchivedFarmsData, userDataLoaded = farms.userDataLoaded, poolLength = farms.poolLength, regularCakePerBlock = farms.regularCakePerBlock;
        return {
            loadArchivedFarmsData: loadArchivedFarmsData,
            userDataLoaded: userDataLoaded,
            data: deserializedFarmsData,
            poolLength: poolLength,
            regularCakePerBlock: regularCakePerBlock
        };
    });
};

;// CONCATENATED MODULE: ./src/state/farms/hooks.ts


















function useFarmsLength() {
    var chainId = useActiveWeb3React().chainId;
    return useSWRImmutable(chainId ? [
        "farmsLength",
        chainId
    ] : null, /*#__PURE__*/ _async_to_generator(function() {
        var mc;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    mc = getMasterchefContract(undefined, chainId);
                    return [
                        4,
                        mc.poolLength()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent().toNumber()
                    ];
            }
        });
    }));
}
var usePollFarmsWithUserData = function() {
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var ref = (0,hooks_useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var ref1 = (0,useBCakeProxyContractAddress/* useBCakeProxyContractAddress */.A)(account, chainId), proxyAddress = ref1.proxyAddress, proxyCreated = ref1.proxyCreated, isProxyContractLoading = ref1.isLoading;
    var farmFlag = (0,hooks_useFeatureFlag/* useFeatureFlag */.y)(hooks_useFeatureFlag/* featureFarmApiAtom */.x);
    (0,dist/* default */.Z)(chainId ? [
        "publicFarmData",
        chainId
    ] : null, /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var farmsConfig, pids;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,farms_constants.getFarmConfig)(chainId)
                    ];
                case 1:
                    farmsConfig = _state.sent();
                    pids = farmsConfig.map(function(farmToFetch) {
                        return farmToFetch.pid;
                    });
                    dispatch((0,farms/* fetchFarmsPublicDataAsync */.eG)({
                        pids: pids,
                        chainId: chainId,
                        flag: farmFlag
                    }));
                    return [
                        2
                    ];
            }
        });
    }), {
        refreshInterval: farmFlag === "api" ? 50 * 1000 : constants/* SLOW_INTERVAL */.KI
    });
    var name = proxyCreated ? [
        "farmsWithUserData",
        account,
        proxyAddress,
        chainId
    ] : [
        "farmsWithUserData",
        account,
        chainId
    ];
    (0,dist/* default */.Z)(account && chainId && !isProxyContractLoading ? name : null, /*#__PURE__*/ (0,src_async_to_generator/* default */.Z)(function() {
        var farmsConfig, pids, params;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,farms_constants.getFarmConfig)(chainId)
                    ];
                case 1:
                    farmsConfig = _state.sent();
                    pids = farmsConfig.map(function(farmToFetch) {
                        return farmToFetch.pid;
                    });
                    params = proxyCreated ? {
                        account: account,
                        pids: pids,
                        proxyAddress: proxyAddress,
                        chainId: chainId
                    } : {
                        account: account,
                        pids: pids,
                        chainId: chainId
                    };
                    dispatch((0,farms/* fetchFarmUserDataAsync */.IV)(params));
                    return [
                        2
                    ];
            }
        });
    }), {
        refreshInterval: constants/* SLOW_INTERVAL */.KI
    });
};
/**
 * Fetches the "core" farm data used globally
 * 2 = CAKE-BNB LP
 * 3 = BUSD-BNB LP
 */ var coreFarmPIDs = {
    56: [
        2,
        3
    ],
    97: [
        4,
        10
    ],
    5: [
        13,
        11
    ],
    1: [
        124,
        125
    ]
};
var usePollCoreFarmData = function() {
    var dispatch = useAppDispatch();
    var chainId = useActiveWeb3React().chainId;
    var farmFlag = useFeatureFlag(featureFarmApiAtom);
    useEffect(function() {
        if (chainId) {
            dispatch(fetchInitialFarmsData({
                chainId: chainId
            }));
        }
    }, [
        chainId,
        dispatch
    ]);
    useFastRefreshEffect(function() {
        if (chainId && farmFlag !== "api") {
            dispatch(fetchFarmsPublicDataAsync({
                pids: coreFarmPIDs[chainId],
                chainId: chainId,
                flag: farmFlag
            }));
        }
    }, [
        dispatch,
        chainId,
        farmFlag
    ]);
};
var useFarms = function() {
    var chainId = (0,hooks_useActiveWeb3React/* default */.Z)().chainId;
    return (0,es/* useSelector */.v9)((0,react.useMemo)(function() {
        return farmSelector(chainId);
    }, [
        chainId
    ]));
};
var useFarmsPoolLength = function() {
    return useSelector(function(state) {
        return state.farms.poolLength;
    });
};
var useFarmFromPid = function(pid) {
    var farmFromPid = (0,react.useMemo)(function() {
        return makeFarmFromPidSelector(pid);
    }, [
        pid
    ]);
    return (0,es/* useSelector */.v9)(farmFromPid);
};
var useFarmFromLpSymbol = function(lpSymbol) {
    var farmFromLpSymbol = useMemo(function() {
        return farmFromLpSymbolSelector(lpSymbol);
    }, [
        lpSymbol
    ]);
    return useSelector(farmFromLpSymbol);
};
var useFarmUser = function(pid) {
    var farmFromPidUser = (0,react.useMemo)(function() {
        return makeUserFarmFromPidSelector(pid);
    }, [
        pid
    ]);
    return (0,es/* useSelector */.v9)(farmFromPidUser);
};
// Return the base token price for a farm, from a given pid
var useBusdPriceFromPid = function(pid) {
    var busdPriceFromPid = useMemo(function() {
        return makeBusdPriceFromPidSelector(pid);
    }, [
        pid
    ]);
    return useSelector(busdPriceFromPid);
};
var useLpTokenPrice = function(symbol) {
    var lpTokenPriceFromLpSymbol = (0,react.useMemo)(function() {
        return makeLpTokenPriceFromLpSymbolSelector(symbol);
    }, [
        symbol
    ]);
    return (0,es/* useSelector */.v9)(lpTokenPriceFromLpSymbol);
};
/**
 * @deprecated use the BUSD hook in /hooks
 */ var usePriceCakeBusd = function() {
    var forceMainnet = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        forceMainnet: false
    }).forceMainnet;
    var price = (0,useBUSDPrice/* useCakeBusdPrice */.S9)({
        forceMainnet: forceMainnet
    });
    return (0,react.useMemo)(function() {
        return price ? new bignumber/* default */.Z(price.toSignificant(6)) : bigNumber/* BIG_ZERO */.HW;
    }, [
        price
    ]);
};


/***/ }),

/***/ 80922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useBCakeProxyContractAddress; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var config_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42918);
/* harmony import */ var hooks_useContract__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36963);
/* harmony import */ var config_constants_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75759);
/* harmony import */ var _pancakeswap_farms_src_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10006);







var useBCakeProxyContractAddress = function(account, chainId) {
    var bCakeFarmBoosterContract = (0,hooks_useContract__WEBPACK_IMPORTED_MODULE_2__/* .useBCakeFarmBoosterContract */ .gh)();
    var isSupportedChain = _pancakeswap_farms_src_index__WEBPACK_IMPORTED_MODULE_4__/* .bCakeSupportedChainId.includes */ .P4.includes(chainId);
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(account && isSupportedChain && [
        "proxyAddress",
        account
    ], /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            return [
                2,
                bCakeFarmBoosterContract.proxyContract(account)
            ];
        });
    })), data = ref.data, status = ref.status, mutate = ref.mutate;
    var isLoading = isSupportedChain ? status !== config_constants_types__WEBPACK_IMPORTED_MODULE_3__/* .FetchStatus.Fetched */ .iF.Fetched : false;
    return {
        proxyAddress: data,
        isLoading: isLoading,
        proxyCreated: data && data !== config_constants__WEBPACK_IMPORTED_MODULE_1__/* .NO_PROXY_CONTRACT */ .h5,
        refreshProxyAddress: mutate
    };
};


/***/ }),

/***/ 74227:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9919:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 95867:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P1": function() { return /* binding */ createSelector; }
});

// UNUSED EXPORTS: createSelectorCreator, createStructuredSelector, defaultEqualityCheck, defaultMemoize

;// CONCATENATED MODULE: ./node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
;// CONCATENATED MODULE: ./node_modules/reselect/es/index.js



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [719,9689,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);